import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqn } from '@/shared/lib/format';

import type { DomainItem, DomainListResponse } from '@/entities/domain';

type GetDomainsParams = {
  limit?: number;
  after?: string;
};

export const getDomainsApi = async ({ limit = 10000 }: GetDomainsParams = {}): Promise<DomainListResponse> => {
  const { data } = await openMetadataApiClient.get<DomainListResponse>('/domains', {
    params: {
      limit,
      fields: 'parent,children',
    },
  });
  return data;
};

export const getDomainDetailApi = async (domainFqn: string): Promise<DomainItem> => {
  const encodedFqn = encodeOpenMetadataFqn(domainFqn);
  const { data } = await openMetadataApiClient.get<DomainItem>(`/domains/name/${encodedFqn}`, {
    params: {
      fields: 'children,owners,parent,experts,tags,followers,extension',
    },
  });
  return data;
};
